// Detect Node env
export const isNodeEnv = () => typeof window === 'undefined' || typeof document === 'undefined'



//////////////////
// WEBPACK FOOTER
// ./node_modules/sweetalert2/src/utils/isNodeEnv.js
// module id = null
// module chunks = 